import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

// eslint-disable-next-line react/prop-types
export function SubmitButton({ className, children, disabled, onClick }) {
  return (
    // eslint-disable-next-line react/button-has-type
    <button type="submit" className={className} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}

SubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
};
